var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template"},[_c('div',{staticClass:"menu-container"},[_c('Menu')],1),_c('div',{staticClass:"content"},[_c('Header',{staticClass:"header"}),_c('div',{staticClass:"page"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }